import React from 'react';

import SetFromQueryParams from 'features/Cookies/SetFromQueryParams';

const ComponentCallbacks = () => (
  <>
    <SetFromQueryParams />
  </>
);

export default ComponentCallbacks;
